module.exports = __webpack_public_path__ + "static/media/beachNight.eca2f697.jpg";